import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import { routingService } from 'app_services/routingService'
import AuthService from 'app_services/secure/auth/authService'
import React, { FC, useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import LoginMoodle from 'app_components/modules/LoginMoodle/LoginMoodle'
import useWindowWidth from 'app_hooks/useWindowWidth'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { BsThreeDotsVertical } from 'react-icons/bs'
import DropDownComponent from 'app_components/commons/DropDownComponent/DropDownComponent'

import './StudentsHeader.scss'

interface IStudentsHeaderProps {

}

const MOBILE_BREAKPOINT = 800

const StudentsHeader: FC<IStudentsHeaderProps> = () => {
  const authService = useMemo(() => new AuthService(), [])
  const { windowWidth } = useWindowWidth()

  const onHandleLogout = useCallback(() => {
    authService.logout()
  }, [authService])

  return (
    <div className="students-header--layout">
      {windowWidth && windowWidth > MOBILE_BREAKPOINT ? (
        <div id="students_header" className="students-header--content">
          <Link to={routingService.getPublicPath()}>
            <ButtonComponent className='students-header--button-white'>
              Campus
            </ButtonComponent>
          </Link>
          <LoginMoodle targetBlank>
            <ButtonComponent
              className='students-header--button'
              variant="secondary"
              type="button"
            >
              Ingreso a cursos
            </ButtonComponent>
          </LoginMoodle>
          <ButtonComponent
            className='students-header--button-white'
            onClick={onHandleLogout}
          >
            Salir
          </ButtonComponent>
        </div>
      ) : (
        <div id="students_header" className='students-header--mobile-content'>
          <div/>
          <Link to={routingService.getPublicPath()}>
            <TextComponent fontSize="22px" color="#C0E8FF">
              Campus ICONTEC
            </TextComponent>
          </Link>
          <DropDownComponent
            className='students-header--mobile-dropdown'
            classNameToggle='students-header--mobile-dropdown-toggle'
            title=''
            toggleComponent={(
              <div className='students-header--mobile-icon'>
                <BsThreeDotsVertical />
              </div>
            )}
          >
            <DropDownComponent.Item>
              <LoginMoodle targetBlank>
                <TextComponent color="black">
                  Ingreso a cursos
                </TextComponent>
              </LoginMoodle>
            </DropDownComponent.Item>
            <DropDownComponent.Item>
              <TextComponent color="black" onClick={onHandleLogout}>
                Salir
              </TextComponent>
            </DropDownComponent.Item>
          </DropDownComponent>
        </div>
      )}
    </div>
  )
}

export default StudentsHeader
